import React from "react"
import PropTypes from "prop-types"

function Search(props) {
  return (
    <div className="searchContainer" style={{display: 'flex'}}>
      <input
        className="searchInput"
        value={props.value}
        placeholder={props.placeholder}
        onChange={(event) => props.onChange(event.target.value)}
      />
    </div>
  );
}

export default Search
